<template>
  <BModal size="lg" body-class="p-5 rounded-lg" :visible="visible" hide-header hide-footer @hide="$emit('hide', true)">
    <div class="text-center">
      <i class="fas fa-location-arrow fa-5x mb-4 text-callout" />
      <h4 v-if="user && user.current_company" class="font-weight-bold">
        Hello {{ user.name }} from <span class="font-weight-bold">{{ user.current_company.name }}</span>
      </h4>

      <p class="">You are not associated with any buyer companies so you will be unable to order products.</p>
      <div class="shadow-sm bg-light rounded-lg p-4">
        <p class="font-weight-bold">
          To order products you can create an account for a new company or request to be added to an existing company by clicking the button below.
        </p>
        <BushelBtn variant="success"> Create Buyer Company </BushelBtn>
      </div>
    </div>
  </BModal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
    },
  },
  emits: ["hide"],
  data() {
    return {};
  },
};
</script>
